function readEnv(key: keyof ImportMetaEnv, fallback?: string): string {
  const value = import.meta.env[key] ?? fallback
  if (value === undefined) {
    throw new Error(`Falta la variable de entorno requerida: ${key}`)
  }
  return value
}

export const env = {
  apiBaseUrl: readEnv('VITE_API_BASE_URL', 'http://localhost:8000'),
  apiV1Prefix: readEnv('VITE_API_V1_PREFIX', '/api/v1'),
  appName: readEnv('VITE_APP_NAME', 'GOVIA 2.0'),
  mapTileUrl: readEnv(
    'VITE_MAP_TILE_URL',
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  ),
  mapAttribution: readEnv('VITE_MAP_ATTRIBUTION', '&copy; OpenStreetMap contributors'),
  /**
   * Fase 9 (Controlled Pre-Migration) — interruptor de release preparado
   * pero INACTIVO: ningún archivo lo lee todavía para decidir qué se
   * renderiza en ninguna ruta. `/` sigue sirviendo `DashboardPage` (V1) de
   * forma incondicional, exactamente igual que antes de esta fase. Existe
   * para que el cutover futuro (mover `/` y `/govia-ai` a V2) pueda
   * activarse cambiando ESTA variable de entorno, en vez de reescribir
   * `AppRoutes.tsx` — ver el reporte de cierre de Fase 9 para el diff
   * exacto que se aplicaría en el momento del cutover autorizado.
   */
  uiDefaultVersion: readEnv('VITE_GOVIA_UI_VERSION', 'v1') as 'v1' | 'v2',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const

export const apiUrl = `${env.apiBaseUrl}${env.apiV1Prefix}`
